var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$.column }, [
    _c(
      "div",
      { class: _vm.$.header },
      [
        _c("skeleton-item", {
          style: { height: "20px", width: "72px" },
          attrs: { type: "bar" },
        }),
        _vm._v(" "),
        _c("skeleton-item", { attrs: { type: "square", size: "xs" } }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$.column_content },
      [
        _vm._l(_vm.data.cards, function (card, i) {
          return _c("card-skeleton", {
            key: "card_skeleton_" + _vm.data.id + "_" + i,
            attrs: { type: card },
          })
        }),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$.content_footer },
          [
            _c("skeleton-item", { attrs: { type: "square", size: "sm" } }),
            _vm._v(" "),
            _c("skeleton-item", {
              style: { height: "12px", width: "80px" },
              attrs: { type: "bar" },
            }),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }